import React from 'react';
import styled  from 'styled-components';


const StyledComp = styled.div`
width: 100%;
height: 100%;
position: relative;
video{
  min-height: 100%;
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;

}
`;

const Comp = ({}) => {
  return (
  <StyledComp aria-hidden="true">
      <video autoPlay loop muted playsInline src={'https://cdn.studio14a.com/axion/blackdith.mp4'} />
  </StyledComp>
  );
};

export default Comp;
